import { render, staticRenderFns } from "./Autorizador.vue?vue&type=template&id=ebabfd34"
import script from "./Autorizador.vue?vue&type=script&lang=js"
export * from "./Autorizador.vue?vue&type=script&lang=js"
import style0 from "./Autorizador.vue?vue&type=style&index=0&id=ebabfd34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports